import { combine, createEffect, createEvent, createStore } from 'effector';
import { saveAs } from 'file-saver';
import { $notificationStore } from '../notificationStore';
import { TransferRequestsApi, type TransferRequestDownloadDocumentRequest, type TransferRequestDownloadDocumentResponse } from '@shared/api';

const downloadDocumentEffect = createEffect((request: TransferRequestDownloadDocumentRequest) => TransferRequestsApi.downloadDocument(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestDownloadDocumentResponse | null>(null)
  .on(downloadDocumentEffect.done, (_, data) => data.result.data)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(downloadDocumentEffect.pending, (_, data) => data)
  .on(downloadDocumentEffect.fail, () => false)
  .on(downloadDocumentEffect.done, () => false)
  .reset(clearEvent);

downloadDocumentEffect.done.watch((result) =>
  saveAs(`data:${result.result.data?.contentType};base64,${result.result.data?.data}`, result.result.data?.fileName),
);
downloadDocumentEffect.fail.watch(() => $notificationStore.events.setError('Something went wrong while downloading Document. Please try again.'));

export const $downloadDocumentStore = {
  events: {
    download: downloadDocumentEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
  }),
};
